import {css} from "@panda/css";

// The lead button and the secondary CTA of the contact bar split its row evenly, so neither label decides the width.
// Shared with the CTA rendered in that row, which has to size itself the same way.
export const contactBarRowButtonStyle = css({
    flex: "1 1 0",
    minWidth: 0,
    px: 1
});
import {css} from "@panda/css";

// The lead button and the secondary CTA of the contact bar split its row evenly, so neither label decides the width.
// Shared with the CTA rendered in that row, which has to size itself the same way.
export const contactBarRowButtonStyle = css({
    flex: "1 1 0",
    minWidth: 0,
    px: 1
});
